import React from 'react'
import DownArrowSmallIcon from '../../icons/DownArrowSmallIcon'
import { ClickAwayListener, Popper } from '@mui/material'

import useStyles from './styles'

interface DropdownV2Props {
  options: any[]
  renderOption?: (value: any) => any
  disablePortal?: boolean
  value?: any
  onSelect: Function
  disabled?: boolean
}

const DropdownV2: React.FC<DropdownV2Props> = ({
  options,
  renderOption,
  disablePortal,
  value,
  onSelect,
  disabled
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = React.useMemo(() => Boolean(anchorEl), [anchorEl])
  const mainRef = React.useRef()

  const classes = useStyles({ disabled })

  // Opens menu
  const handleClick = React.useCallback(
    e => {
      if (!disabled) {
        const target = e.currentTarget
        setAnchorEl(old => (old ? null : target))
      }
    },
    [disabled]
  )

  // Closes menu and resets state
  const handleClose = React.useCallback(() => {
    setAnchorEl(null)
  }, [])

  // Callback for when something is clicked
  const handleSelect = React.useCallback(
    id => {
      onSelect && onSelect(id)

      handleClose()
    },
    [onSelect, handleClose]
  )

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div>
        <div ref={mainRef} onClick={handleClick} className={classes.root}>
          <div className={classes.selected}>
            {Boolean(value) ? (
              renderOption ? (
                renderOption(value)
              ) : (
                value
              )
            ) : (
              <label className={classes.noSelected}>None</label>
            )}
          </div>
          <DownArrowSmallIcon style={{ flexShrink: 0 }} />
        </div>

        {open && (
          <Popper
            open={open}
            disablePortal={disablePortal}
            anchorEl={anchorEl}
            style={{ zIndex: '1500' }}
            placement='bottom-start'
          >
            <div className={classes.menu}>
              <div className={classes.items}>
                {options.map((opt, index) => (
                  <div
                    key={`${index} - ${opt?.id || opt}`}
                    onClick={() => handleSelect(opt)}
                    className={classes.item}
                  >
                    {renderOption ? renderOption(opt) : opt}
                  </div>
                ))}
              </div>
            </div>
          </Popper>
        )}
      </div>
    </ClickAwayListener>
  )
}

export default DropdownV2
